import React, { useEffect, useState } from 'react';
import { useModal } from '../../../../../hooks/Modal';
import api from "../../../../../services/api"
import { simpleDateBR } from "../../../../../utils/date";
import { FaQrcode } from 'react-icons/fa';
import lineModules from '../../../core/components/lineModules';
import useCrachaLoteAgendamento from '../../../core/components/lineModules/CrachaLoteAgendamentoFunction';
import { Form } from '@unform/web';
import Input from '../../../core/components/Forms/Input';


const Order = () => {
const {handleQR} = useCrachaLoteAgendamento();

const  [list, setList] = useState<Record<string,any>>([]);
const [search, setSearch] = useState('');


const filter = search ? list.filter( item => item?.name?.toLowerCase()?.trim()?.indexOf(search?.toLowerCase()?.trim() ) >= 0 || 
item?.company?.toLowerCase()?.trim()?.indexOf(search?.toLowerCase()?.trim() ) >= 0 ||
item?.hour?.toLowerCase()?.trim()?.indexOf(search?.toLowerCase()?.trim() ) >= 0

) : list;

const load = async () => {

const listV = await api.get(`/visitation-calendar-subscriptions`, {params: { limitItems: 10000}});

const items = listV?.data?.rows;


 items.sort( (a,b) => {

    const aDate = `${a?.date} ${a?.hour} ${a?.company} ${a?.name} `;
    const bDate = `${b?.date} ${b?.hour} ${b?.company} ${b?.name}`;
    return aDate < bDate ? -1 :  aDate > bDate ? 1 : 0;

})


setList(items)

}

useEffect(() => {

load()

},[])

return <>

<Form onSubmit={() => {}}>

<Input name='search' setCallback={(value => setSearch(value))} placeholder='Pesquisar'/>

</Form>


<table className="tableRef full-width">

<tbody>
 <tr><td></td><td>Nº</td><td>Data</td><td>Hora</td><td>Escola</td><td>Professor</td><td>Alunos</td></tr>
 {filter?.map( (item, index) => {

return <tr>
    <td><button onClick={() => {handleQR({lineData: item})}} className='buttonAdmin active'>Imprimir</button></td>
    <td>{index +1}</td>
    <td>{simpleDateBR(item?.date)}</td>
    <td>{item?.hour}</td>
          <td>{item?.company}</td>
    <td>{item?.name}</td>

    <td>{item?.quantity}</td>

</tr>

 })}



</tbody>



</table>
</>

}


export default function ListInOrder(): JSX.Element {

const {addModal} = useModal();


const getList = async () => {





addModal({title: '', key:'modalQr', theme: 'whiteModal', content: <Order/> })

}




return <button className='searchButton' type='button' onClick={() => getList()}><FaQrcode title="Imprimir lista geral" /></button>




}